import React from 'react'
import {Component} from 'react'
import getImageSize from '../functions/get-image-size'
import toClassName  from '../functions/to-class-name'
import BackgroundCarousel from './background-carousel';
import './page-header--event-single.scss'

export default class extends Component {
  getBackgroundImage(){
    var image = THEME_DIR_URI + '/images/placeholder-truck.svg'
    if( this.props.market.imageUrl ){
      image = getImageSize( '--medium', this.props.market.imageUrl )
    }
    return 'url(' + image + ')'
  }
  formatStatus( status ) {
    switch( status ) {
      case 'opentoday':
        status = 'open today';
        break;
      case 'opennow':
        status = 'open now';
        break;
    }
    return status;
  }
  render(){
    const { logo, video, carousel, cta, ctaDarkSide, ctaID, ctaAnalytics } = this.props
    return (
      <header className={`page-header page-header--event-single ${cta ? ' has-cta' : ''} ${carousel ? ' has-carousel' : ''}`} style={ { backgroundImage: this.getBackgroundImage() } } >
        { this.props.market.status != 'closed' &&
          <div className={toClassName([
            "event-status-wrap-mobile",
            this.props.locationExtras &&
            this.props.locationExtras.cta_button &&
            this.props.locationExtras.cta_button.url ? 'event-status-wrap-mobile--bottom' : undefined
            ])}
            >
            <span
              className={ toClassName( [
                'button',
                'button--small',
                'event-status',
                this.props.market.status,
              ] ) } >
              <i className="fa fa-clock-o"></i>
              { this.formatStatus(this.props.market.status) }
            </span>
          </div>}

          { this.props.locationExtras &&
            this.props.locationExtras.cta_button &&
            this.props.locationExtras.cta_button.url &&
            this.props.locationExtras.cta_button.text &&
            <a href={this.props.locationExtras.cta_button.url} className="location-cta-button button button--small" >
              {this.props.locationExtras.cta_button.text}
            </a>
          }

          { video && !carousel && <div className="page-header__background__video"><video autoPlay loop muted playsInline><source src={ video['url'] } type="video/mp4"></source></video></div> }
          { video && !carousel && <div className="page-header__background__video page-header__background__video--mobile"><video autoPlay loop muted playsInline><source src={ video['url'] } type="video/mp4"></source></video></div> }
          { carousel &&
          <BackgroundCarousel slides={carousel} />
          }
          <button className="button button--small btn-scroll-to-vendors view-vendors-button">
            <i className="fa fa-angle-double-down"></i>
              <span>View Vendor List</span>
          </button>

          <div className="event-intro">
            <h1 className="h1 page-header--event-single__title">
              { logo && <img className="page-header--event-single__logo" src={ logo } alt="" /> }
              { this.props.heading || this.props.market.name || 'Loading...' }
            </h1>
            { cta &&
              <div className="page-header--event-single__spacer"></div>
            }
            <p>Upcoming Schedule:</p>
            { cta &&
              <a
                className = "event-clickthrough event-clickthrough--desktop"
                href={ cta.url }
                target={ cta.target ? cta.target : undefined }
                id={ ctaID }
                onClick={ ()=>{ ctaAnalytics && ga( "send", "event", ctaAnalytics ) } }
                >
                <div className="event-clickthrough__text">
                  <div className="event-clichkthrough__vertical-centered">
                  { cta.title }
                  </div>
                </div>
                <div className="event-clickthrough__additional-text">
                  <div className="event-clickthrough__additional-text__content">
                  { ctaDarkSide }
                  </div>
                </div>
              </a>
            }
          </div>
          { cta &&
            <a
            className = "event-clickthrough event-clickthrough--mobile"
            href={ cta.url }
            target={ cta.target ? cta.target : undefined }
            id={ ctaID }
            onClick={ ()=>{ ctaAnalytics && ga( "send", "event", ctaAnalytics ) } }
            >
            <div className="event-clickthrough__text">
              <div className="event-clichkthrough__vertical-centered">
              { cta.title }
              </div>
            </div>
          </a>
          }
      </header>
    )
  }
}
